import React from 'react';
import ReactDOM from 'react-dom';

const Overlay = ({ children }) => (
  <div className="fixed inset-0" aria-modal="true" role="dialog" style={{ zIndex: 99999999999 }}>
    <div className="absolute inset-0 backdrop-blur-md" style={{ backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 99999999998 }} />
    <div className="relative flex h-full w-full items-center justify-center p-4" style={{ zIndex: 99999999999 }}>
      <div className="w-full max-w-4xl rounded-2xl bg-white p-8 shadow-2xl max-h-[95vh] overflow-y-auto" style={{ zIndex: 99999999999 }}>
        {children}
      </div>
    </div>
  </div>
);

export default function Modal({ children }) {
  React.useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = original; };
  }, []);
  const container = React.useMemo(() => {
    const el = document.createElement('div');
    el.setAttribute('data-modernized-onboarding-portal', '');
    return el;
  }, []);

  React.useEffect(() => {
    document.body.appendChild(container);
    return () => {
      try { document.body.removeChild(container); } catch (_) {}
    };
  }, [container]);

  return ReactDOM.createPortal(<Overlay>{children}</Overlay>, container);
}


